
const InfoIcon = ({ size = 14, color = "#222222" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.78125 0.21875C10.5 0.21875 13.5625 3.28125 13.5625 7C13.5625 10.7461 10.5 13.7812 6.78125 13.7812C3.03516 13.7812 0 10.7461 0 7C0 3.28125 3.03516 0.21875 6.78125 0.21875ZM6.78125 3.22656C6.125 3.22656 5.63281 3.74609 5.63281 4.375C5.63281 5.03125 6.125 5.52344 6.78125 5.52344C7.41016 5.52344 7.92969 5.03125 7.92969 4.375C7.92969 3.74609 7.41016 3.22656 6.78125 3.22656ZM8.3125 10.1719V9.51562C8.3125 9.35156 8.14844 9.1875 7.98438 9.1875H7.65625V6.45312C7.65625 6.28906 7.49219 6.125 7.32812 6.125H5.57812C5.38672 6.125 5.25 6.28906 5.25 6.45312V7.10938C5.25 7.30078 5.38672 7.4375 5.57812 7.4375H5.90625V9.1875H5.57812C5.38672 9.1875 5.25 9.35156 5.25 9.51562V10.1719C5.25 10.3633 5.38672 10.5 5.57812 10.5H7.98438C8.14844 10.5 8.3125 10.3633 8.3125 10.1719Z"
      fill={color}
    />
  </svg>
);

export default InfoIcon;
